(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stylist-video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
